import { COUNTERPARTY_MASTER_DATA_INITIAL_LOAD } from './action';

const counterpartyMasterDataInitialValuesReducer = (state = {}, action) => {
    switch (action.type) {
        case COUNTERPARTY_MASTER_DATA_INITIAL_LOAD:
            return {
                ...state,
                intialCounterpartyMasterData: action.data
            }

        default:
            return state
    }
}

export default counterpartyMasterDataInitialValuesReducer;